import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { Link } from '../../partials/link/Link';
import { BaseUnit } from '../../../theming/baseUnitDefinition';

const componentConfigThemeKey = 'authorPageSocial';

export interface SocialButton {
  link: string;
  src: string;
  alt: string;
}

interface HorizontalSocialButtonsWrapperDataProps {
  buttons: SocialButton[];
}

interface HorizontalSocialButtonsWrapperThemeProps {
  baseUnit: BaseUnit;
  backgroundColor: string;
}

const getStyle = (baseUnit: BaseUnit, backgroundColor: string) => StyleSheet.create({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  socialButton: {
    display: 'flex',
    width: '32px',
    height: '32px',
    borderRadius: '100%',
    overflow: 'hidden',
    backgroundColor,
    justifyContent: 'center',
    alignItems: 'center',
    margin: `0 ${baseUnit / 4}px`,
  },
});

export const HorizontalSocialButtonsWrapper: React.FunctionComponent<HorizontalSocialButtonsWrapperDataProps> = props => {
  const { buttons } = props;
  const { baseUnit, backgroundColor } = useTheme<HorizontalSocialButtonsWrapperThemeProps>(componentConfigThemeKey);
  const style = getStyle(baseUnit, backgroundColor);
  return (
    <ErrorBoundary>
      <div className={css(style.wrapper)}>
        {
          buttons.map((button, index) => (
            <Link className={css(style.socialButton)} key={index} href={button.link}>
              <img src={button.src} alt={button.alt} />
            </Link>
          ))
        }
      </div>
    </ErrorBoundary>
  );
};
